import Vue from "vue";
import axios from "axios";
import { authService } from "../service/authService";
import store from "../store/store";
// import mainAuth from "../plugins/auth";
import router from "@/router"


const axiosInstance = axios.create({
  // baseURL: "https://apiadmin.tebyan.net/"
});
// axiosInstance.defaults.params = { salam: 'salam' };
axiosInstance.interceptors.request.use(config => {
  config.headers["Authorization"] = `Bearer ${authService().getToken()}`;
    store.commit("SET_OVERLAY", true);
    // if(config.method == 'get'){
    //   let userInfo = store.getters["userInfo/getUserInfo"];
    //   if(userInfo){
    //     if(userInfo.level != 0){
    //     config.params = { scope: userInfo.scope}
    //     }
    //
    //   }
    // }
  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    //store.dispatch("app/setOverlay",false);
    if (response.status === 201 || response.status === 202 || response.status === 204) {
      let text = 'عملیات با موفقیت انجام شد'
      Vue.$toast.success(text);
    }
    // setTimeout(() => {
    //   store.commit("SET_OVERLAY", false);
    // }, 3000);
    store.commit("SET_OVERLAY", false);
    return response;
  },
  error => {
    //console.log(error, "axios error");
    setTimeout(() => {
      store.commit("SET_OVERLAY", false);
    }, 1500);
    //store.dispatch("app/setOverlay",false);

    if (error.response.status) {

      if (error.response.status === 404) {
        //router.push({ name: "Page404" });
      } else if (error.response.status === 403) {
         router.push({ name: "Page403" });
      } else if (error.response.status === 401) {
        router.push({ name: "Page403" });
      } else if (error.response.status === 400) {
        let text=error.response.data.msg;
        Vue.$toast.error(text);
       // console.log("axios config");
       // router.push({ name: "Login" });
      } else if (error.response.status >= 500) {
        let  text= 'عملیات انجام نشد'
        Vue.$toast.error(text);
      }else{

      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
